import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationDTO } from '../../core/models/dto/notification.dto';
import { NotificationType } from '../../core/enums/notification-type.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'notificationExplanatoryText' })
export class NotificationExplanatoryTextPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(notification: NotificationDTO): string {
        switch (notification.type) {
            case NotificationType.mentionInNote: {
                return this.translateService.instant('mentioned you in a note:');
            }
            case NotificationType.answerToNote: {
                return this.translateService.instant('commented your note:');
            }
            case NotificationType.reply: {
                return (
                    this.translateService.instant('answered one of your replies') +
                    (notification.count > 1 ? ' (' + notification.count + '):' : ':')
                );
            }
            case NotificationType.subReply: {
                return this.translateService.instant('answered one of your replies:');
            }
            case NotificationType.ticketReminder:
            case NotificationType.replyReminder: {
                return (
                    this.translateService.instant('Reminder time has ended. Please check') +
                    ' ' +
                    (notification.type === NotificationType.ticketReminder
                        ? this.translateService.instant('ticket')
                        : this.translateService.instant('reply')) +
                    ' "' +
                    notification.message.text +
                    '" ' +
                    this.translateService.instant('from') +
                    ' ' +
                    notification.message.author.name +
                    '.'
                );
            }
            case NotificationType.ticketSurveyResponseAdded: {
                return notification.message.text;
            }
            case NotificationType.emailDeliveryStatusUpdate: {
                return notification.message?.text || this.translateService.instant('Email delivery failed');
            }
        }
    }
}
